import Badge from '@codegouvfr/react-dsfr/Badge';
import { cx } from '@codegouvfr/react-dsfr/fr/cx';
import type { DisplayStatusResult } from 'maestro-shared/schema/ProgrammingPlan/ProgrammingPlanDisplayStatus';
import { formatDate } from 'maestro-shared/utils/date';

interface Props {
  result: DisplayStatusResult;
  showDates?: boolean;
  small?: boolean;
}

const severityByValue = {
  Submitted: 'success',
  InProgress: 'new',
  Pending: undefined,
  ReadyToSend: 'info',
  NotApplicable: undefined
} as const;

const ProgrammingPlanDisplayStatusBadge = ({
  result,
  showDates,
  small
}: Props) => {
  if (result.value === 'NotApplicable') {
    return <span className={cx('fr-text--sm')}>N/A</span>;
  }

  return (
    <div className="align-left">
      <Badge severity={severityByValue[result.value]} noIcon small={small}>
        {result.label}
      </Badge>
      {showDates && result.sentAt && (
        <div className={cx('fr-text--xs', 'fr-mt-1v')}>
          Envoyé le {formatDate(result.sentAt)}
          {result.lastModifiedAt && (
            <> · Modifié le {formatDate(result.lastModifiedAt)}</>
          )}
        </div>
      )}
    </div>
  );
};

export default ProgrammingPlanDisplayStatusBadge;
